import { ContactInfo } from "./contactInfo.model"
import { Deserializable } from "./deserializable.model"


export class Shipment implements Deserializable {
    shipmentID?: string
    sender: ContactInfo = new ContactInfo()
    receiver: ContactInfo = new ContactInfo()
    //Shipment specific info
    from: string
    to: string
    status: string
    sType: string
    weight: string
    freightMode: string
    vessel: string
    departureDate: string
    pickupDate: string
    currentLocation: string
    description: string
    comment: string

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}